import { store } from '../../store';
import { setIsModalOpen, setModalContent } from '../../store/slices/global';
import { MODAL_CONTENT } from '../../app.config.vars/modalContent';
export async function fetchInterceptor(input, init) {
    try {
        const response = await fetch(input, init);
        if (response.status >= 500) {
            store.dispatch(setIsModalOpen(true));
            store.dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
            throw new Error(`Server error: ${response.status}`);
        }
        return response;
    }
    catch (error) {
        if (error instanceof TypeError) {
            throw new Error('no_internet');
        }
        throw error;
    }
}
export async function makeOpenApiRequest(url, method, body, localeHeader = '0') {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Locale': localeHeader,
    };
    const init = { method, headers };
    if (body) {
        init.body = JSON.stringify(body);
    }
    try {
        const response = await fetchInterceptor(url, init);
        const data = await response.json();
        return { response, data };
    }
    catch (error) {
        if (error instanceof Error && error.message === 'no_internet') {
            return {
                response: { ok: false },
                data: { error: { code: 'no_internet', message: 'No internet connection' } },
            };
        }
        throw error;
    }
}
export async function makePrivateApiRequest(url, method, token, body, localeHeader = '0') {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Locale': localeHeader,
        Authorization: `Bearer ${token}`,
    };
    const init = { method, headers };
    if (body) {
        init.body = JSON.stringify(body);
    }
    try {
        const response = await fetchInterceptor(url, init);
        const data = await response.json();
        return { response, data };
    }
    catch (error) {
        if (error instanceof Error && error.message === 'no_internet') {
            return {
                response: { ok: false },
                data: { error: { code: 'no_internet', message: 'No internet connection' } },
            };
        }
        throw error;
    }
}
